import { Component, Input } from '@angular/core';
import { StatusDomainName, StatusTone, statusFor } from '../../design/status-tones';

@Component({
  selector: 'ss-status-chip',
  template: `
    <span class="ss-status-chip ss-status-chip--{{ resolvedTone }}" [class.ss-status-chip--caps]="caps" [class.ss-status-chip--compact]="compact">
      <span class="ss-status-chip__dot" aria-hidden="true"></span>{{ resolvedLabel }}
    </span>
  `,
  standalone: false
})
export class StatusChipComponent {
  @Input() domain?: StatusDomainName;
  @Input() value?: string | boolean | null;
  @Input() tone?: StatusTone;
  @Input() label?: string;
  @Input() caps = false;
  @Input() compact = false;

  get resolvedTone(): StatusTone {
    return this.tone || (this.domain ? statusFor(this.domain, this.value).tone : 'neutral');
  }

  get resolvedLabel(): string {
    return this.label ?? (this.domain ? statusFor(this.domain, this.value).label : String(this.value ?? ''));
  }
}
